import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth'
import dashboard from './modules/dashboard'
import db_tables from './modules/db_tables'
import sidebar from './modules/sidebar'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        dashboard,
        db_tables,
        sidebar
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js